import AutoNumeric from 'autonumeric';
import type { Options } from 'autonumeric';

const defaultAutoNumericOptions: Partial<Options> = {
	digitGroupSeparator: ' ',
	currencySymbolPlacement: 's',
	unformatOnSubmit: true,
	decimalCharacterAlternative: ',',
	negativePositiveSignPlacement: 'p',
	modifyValueOnWheel: false
};

$(() => {
	console.log("autonumeric_init.ts");
	$('input[data-autonumeric]').each(function () {
		const options = Object.assign({}, defaultAutoNumericOptions);
		Object.assign(options, JSON.parse($(this).attr('data-autonumeric')!));
		const an = new AutoNumeric(this, options);
		SetupPasteNumberReformatter($(this));
		//an.myGetNumValue = function () {
		//	return this.getNumber();
		//};
	});
});

function SetupPasteNumberReformatter(jqEl: JQuery) {
	if (jqEl && jqEl.length > 0) {
		jqEl.on('paste', function (e: JQuery.TriggeredEvent) {
			e.preventDefault();
			const original = e.originalEvent as ClipboardEvent | undefined;
			const pastedText = original?.clipboardData?.getData('text/plain');
			if (pastedText) {
				let text = pastedText.replace(',', '.');
				text = text.replace(/\s/g, '');
				text = text.replace(/[^\d.,-]/g, '');

				const an = AutoNumeric.getAutoNumericElement(jqEl[0]);
				an?.set(text);
			}
			return false;
		});
	};
};
